import {
  FilterMode,
  BotStep_OrderBy,
  BotStep,
  SortOrder,
  BotStep_Filter,
} from "../../../api/graphql";
import { getApiInstance } from "../../../api";
import { nullToUndefinedRecursive } from "../../../common/utils";

export const botStepService = {
  createOne: () => (): Promise<string> => new Promise(() => ""),
  getOne: async (id: string, accessToken: string, activityStore: any) => {
    const api = getApiInstance(accessToken, activityStore);
    const result = await api.botStepOne({ id });
    return result.botStepOne as BotStep;
  },
  getFilteredList: async (
    accessToken: string,
    offset: number,
    take: number,
    searchValue: string,
    _language: string = "es",
    orderBy: BotStep_OrderBy[] | null = null,
    filter: BotStep_Filter | null = null,
    activityStore: any
  ) => {
    const api = getApiInstance(accessToken, activityStore);

    let where: BotStep_Filter | undefined;
    if (searchValue !== "") {
      where = {
        stepId: { contains: searchValue, mode: FilterMode.Insensitive },
      };
    }

    if (filter) {
      if (where) {
        where = { AND: [filter, where] };
      } else {
        where = filter;
      }
    }

    const result = await api.botStepListWithOffset({
      offset,
      take,
      orderBy: orderBy ? orderBy : [{ stepId: SortOrder.Asc }],
      where,
    });
    const list = nullToUndefinedRecursive(
      result.botStepListWithOffset
    ) as BotStep[];
    return { list, orderBy };
  },
};
